import React, { useState, useEffect } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import { useNavigate } from "react-router-dom";
import MDButton from "components/MDButton";
import {
    Autocomplete,
    Avatar,
    CircularProgress,
    ListItemAvatar,
    ListItemText,
    TextField,
    Box, List, ListItem, Grid, Card
} from "@mui/material";
import { T } from "components/alove/Translator";
import { useMaterialUIController } from "context";
import { getAdminStats } from "utils/matchmakerUtils";
import { TablePage } from "components/alove/TablePage";
import { PermissionType } from "models/BO/BoRole";
import { getBrandsDO } from "utils/brandsUtils";
import {  getAllQuestionsDO } from 'utils/questionsUtils';
import { PageNumber } from "accessNumbers";
import { formatDate } from "utils/globalsUtils";

let navigate;
const host = 'dev';
// TODO: No PageNumber for 4.3, please review.

const action = (request, refresh) => { };

function CustomerSupportTickets() {
const pageNumber = PageNumber.QuestionsList;
    navigate = useNavigate();


    const getTableData = async (filters, page) => {
        // if (filters.hasOwnProperty('question') && filters.question) {
        //         filters.question = question;
        // }

        const tableRes = await getAllQuestionsDO();
        ;

        return tableRes;
    };

    const columns = [
        {
          headerName: "Question",
          field: "txt",
          // width: 600,
          flex: 1
        },
        {
          headerName: "Updated",
          field: "updated",
          width: 120,
          renderCell: (params) => formatDate(params.row.updated),
        }
      ];

    return (
        <DashboardLayout>
            <DashboardNavbar />

                <TablePage
                    title="Quetions List"
                    table={{
                        columns,
                        loadNext: getTableData,
                        pagination: true,
                        getTreeDataPath: (row) => [row.questionCategory?.name || 'No Category', row.id],
                        lineClick: (row) => isNaN(Number(row?.id)) ? null : navigate(`/questions/${row?.id}`)

                    }}
                    filters={[
                        {
                            label: "question",
                            type: "search",
                        }
                    ]}
                />
        </DashboardLayout>
    );
}
export default CustomerSupportTickets;